import { Entry } from 'contentful';

import { Container } from '../../../components/Container/Container';
import { Text } from '../../../components/Text/Text';
import { TypeCmsProPFinePrintSkeleton } from '@generated/contentful';

interface IProps {
  cmsProPFinePrint: (
    | Entry<TypeCmsProPFinePrintSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS'>
    | undefined
  )[];
}

export const CMSFinePrintSection = ({ cmsProPFinePrint }: IProps) => {
  return (
    <Container className="pb-sm">
      {cmsProPFinePrint.map(fpItem => {
        if (fpItem === undefined) {
          return <></>;
        }
        const { finePrintText } = fpItem.fields;
        const { id } = fpItem.sys;
        return (
          <Text variant="sm" className="text-abyss italic" key={id}>
            {finePrintText}
          </Text>
        );
      })}
    </Container>
  );
};
